import { AllNewsCard, BackButton } from '@/components';
import APP_CONFIG from '@/config/app';
import React from 'react';
interface AllNewsTemplateProps {
  onBack: () => void;
}
const AllNewsTemplate: React.FC<AllNewsTemplateProps> = ({ onBack }) => {
  return (
    <div className="flex flex-col gap-md">
      <div className="w-auto">
        <BackButton onBackClick={onBack} />
      </div>
      {APP_CONFIG.SHOW_NEWS && <AllNewsCard />}
    </div>
  );
};
export default AllNewsTemplate;
